
const qs = (selector, context = document) => context.querySelector(selector);
const qsa = (selector, context = document) => context.querySelectorAll(selector);
const toggleClass = (el, cls) => el.classList.toggle(cls);
const addClass = (el, cls) => el.classList.add(cls);
const removeClass = (el, cls) => el.classList.remove(cls);
const onClick = (el, fn) => el?.addEventListener("click", fn);
const setMultipleListeners = (elements, event, fn) => elements.forEach((el) => el.addEventListener(event, fn));

(function() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/Android|BlackBerry|IEMobile|Opera Mini|webOS/i.test(userAgent)) document.body.classList.add('android'); 
})();


class LoadingBar extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("theme:loading:start", this.onLoadingStart.bind(this));
    document.addEventListener("theme:loading:end", this.onLoadingEnd.bind(this));
  }

  onLoadingStart() {
    this.animate([{ opacity: 0, transform: "scaleX(0)" }, { opacity: 1, transform: "scaleX(0.4)" }], { duration: 250, fill: 'forwards'});
  }

  async onLoadingEnd() {
    await this.animate([{ transform: "scaleX(0.4)" }, { transform: "scaleX(1)" }], { duration: 250, fill: 'forwards' }).finished;
    this.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, fill: 'forwards'});
  }
}

if (!window.customElements.get("loading-bar")) {
  window.customElements.define("loading-bar", LoadingBar);
}

/*============================================================================
    CountdownTimer
  ==============================================================================*/
  
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.display = this.querySelector('[data-time-display]');
    this.block = this.closest('.countdown__block--timer');
    this.year = this.el.dataset.year;
    this.month = this.el.dataset.month;
    this.day = this.el.dataset.day;
    this.hour = this.el.dataset.hour;
    this.minute = this.el.dataset.minute;
    this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
    this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
    this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
    this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
    this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
    this.hideTimerOnComplete = this.el.dataset.hideTimer;
    this.completeMessage = this.el.dataset.completeMessage;

    this.timerComplete = false;

    this.init();
  }

  init() {
    setInterval(() => {
      if (!this.timerComplete) {
        this._calculate();
      }
    }, 1000);
  }

  _calculate() {
    // Find time difference and convert to integer
    const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
    // If time difference is greater than 0, calculate remaining time
    if (timeDifference > 0) {
      const intervals = {
        days: this._formatNumber(Math.floor(timeDifference / (1000 * 60 * 60 * 24))),
        hours: this._formatNumber(Math.floor((timeDifference / (1000 * 60 * 60)) % 24)),
        minutes: this._formatNumber(Math.floor((timeDifference / 1000 / 60) % 60)),
        seconds: this._formatNumber(Math.floor((timeDifference / 1000) % 60)),
      };

      this.daysPlaceholder.innerHTML = intervals.days;
      this.hoursPlaceholder.innerHTML = intervals.hours;
      this.minutesPlaceholder.innerHTML = intervals.minutes;
      this.secondsPlaceholder.innerHTML = intervals.seconds;

      setTimeout(() => {
        this.display.classList.add('countdown__display--loaded');
      }, 1);
    } else {
      if (this.completeMessage && this.messagePlaceholder) {
        this.messagePlaceholder.classList.add('countdown__timer-message--visible');
      }

      if (this.hideTimerOnComplete === 'true') {
        this.display.classList.remove('countdown__display--visible');
        this.display.classList.add('countdown__display--hidden');
      }

      if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
        this.block.classList.add('countdown__block--hidden');
      }

      this.timerComplete = true;
    }
  }

  _formatNumber(number) {
    return number < 10 ? '0' + number : number;
  }
}

customElements.define('countdown-timer', CountdownTimer);

function sharePage() {
  navigator.share?.({
      title: document.title,
      text: "Check out this page!",
      url: window.location.href,
    })
    .then(() => console.log("Shared successfully"))
    .catch((error) => console.error("Share error:", error));
}

function initializeShareButton() {
  onClick(document, function(e){
    if(e.target.closest('.share-product')) sharePage();
  })
}

function updateVariantImage() {
  const variants = qsa(".variant-picker__option-values [data-color-product-image]");
  setMultipleListeners(variants, "mouseover", function () {
    let img = this.closest(".product-collection")?.querySelector(".rimage__img");
    if (img) img.srcset = this.dataset.colorProductImage;
  });
}

function handleCartForm() {
  const toggleForm = (el) => toggleClass(el.closest(".product-collection__buttons"), "ShowForm");
  setMultipleListeners(qsa(".addtocart--placeholder"), "click", toggleForm);
  setMultipleListeners(qsa(".close__button"), "click", toggleForm);
}

function copyToClipboard(element) {
  navigator.clipboard.writeText(element.querySelector(".copy__code").value).then(() => {
    const codeElement = element.querySelector(".code");
    const originalText = codeElement.innerText;
    codeElement.innerText = "COPIED";
    setTimeout(() => (codeElement.innerText = originalText), 1200);
  }).catch(console.error);
}

function toggleMobileMenu() {
  onClick(document.getElementById("navigationButton"), (e) => {
    const state = e.target.closest("span") ?.classList.contains("navigationOpenButton") ? "callByName" : "closeByName";
    theme.Popups[state]("navigation");

    let headerHeight = getVisibleHeight(qs('header-section'));
    let announcementBar = qs('.announcement-bar');
    let height = announcementBar ? headerHeight + getVisibleHeight(announcementBar) : headerHeight;
    
    document.body.style.setProperty('--scroll-top', `${height}px`);
  });
}
function toggleCollectionX() {
  onClick(document.querySelector(".collection-control__view-wrapper .collection-control__button-sidebar"), (e) => {
    let headerHeight = getVisibleHeight(qs('header-section'));
    let announcementBar = qs('.announcement-bar');
    let height = announcementBar ? headerHeight + getVisibleHeight(announcementBar) : headerHeight;
    
    document.body.style.setProperty('--scroll-top', `${height}px`);
  });
}

function initializeGridSwitcher() {
  const container = document.getElementById("imageGridSwitcher");
  if (!container) return;
  let btns = qsa(".switch", container);
  setMultipleListeners(btns, "click", function () {
    btns.forEach((btn) => removeClass(btn, "selected"));
    addClass(this, "selected");
    removeClass(document.body, "collection-grid-size-3");
    removeClass(document.body, "collection-grid-size-4");
    addClass(document.body, `collection-grid-size-${this.dataset.grid}`);
    window.dispatchEvent(new Event("resize"));
    if(initializeSlider) initializeSlider(true);
  });
}

function generateProductHTML(product, index) {
  // const productImage = product.media.find(item => item.alt && item.alt.includes('#color_')) || "";
  const productImage =product.variants?.[0]?.featured_image?.src ||
  product.variants?.[0]?.image?.src ||
  product.featured_image ||
  "";

  const altText = product.media?.[0]?.alt || "";
  const priceFormatted = Shopify.formatMoney(product.price, theme.moneyFormat);
  const compareAtPriceFormatted = Shopify.formatMoney(product.compare_at_price, theme.moneyFormat);
  const variantId = product.variants?.[0]?.id || "";

  // Only render compare-at-price if it's actually greater than the base price:
  let compareSpan = "";
  if (
    typeof product.compare_at_price === "number" &&
    product.compare_at_price > product.price
  ) {
    compareSpan = `<span class="compareatpricex">${compareAtPriceFormatted}</span>`;
  }

  return `
    <product-item
      class="product-item"
      data-js-product
      data-js-product-json-preload
      data-product-handle="${product.handle}"
      data-product-variant-id="${variantId}"
      data-qv-check-change
    >
      <div class="Image">
        <img
          class="carousel-cell-image"
          src="${productImage}"
          alt="${altText || product.title}"
        >
      </div>
      <div class="grid-product__meta">
        <div class="related-flex">
          <div class="grid-product__title grid-product__title--body my-10">
            ${product.title}
          </div>
          <div class="grid-product__price price">
            <span class="normalpricex">${priceFormatted}</span>
            ${compareSpan}
          </div>
        </div>
        <button
          type="button"
          class="btn--size-large btn--full custom-button-primary addtocart--placeholder js-popup-button loader--button"
          data-js-popup-button="quick-view"
          data-tippy-content="Quick View"
        >
          Add to Cart
          <div class="custom-loader follow-parent" style="display: none;"></div>
        </button>
      </div>
    </product-item>
  `;
}


// function fetchCartRecommendations(productId, productLimit) {
//   const recommendationsSection = document.getElementById("RelatedProducts");
//   if (!recommendationsSection) return;

//   const baseURL = `${window.location.origin}/recommendations/products.json`;
//   const url = new URL(baseURL);

//   url.searchParams.set("product_id", productId);
//   url.searchParams.set("limit", productLimit);
//   url.searchParams.set("intent", "related");

//   fetch(url)
//     .then((response) => {
//       if (!response.ok) throw new Error("Internet not working");
//       return response.json();
//     })
//     .then((data) => {
//       const products = data?.products || [];
//       if (!products.length) return;

//       const html = products.filter((product) => !product.handle.includes("gift-wrap")).map(generateProductHTML).join("");

//       recommendationsSection.innerHTML = html;

//       setTimeout(() => {
//         const recommendationEvent = new CustomEvent("cart:recommendation:loaded", { detail: { products } });
//         document.dispatchEvent(recommendationEvent);
//       }, 500);
//     })
//     .catch((error) => console.error("Error fetching recommendations:", error));
// }

// function initRecommendation(id) {
//   fetchCartRecommendations(id ? id : document.getElementById("RelatedProducts")?.dataset.default, 10);
// }

// document.addEventListener("theme:cart::added", e => initRecommendation(e.detail.productData?.items[0].product_id));
// document.addEventListener("theme:cart::removed", e => initRecommendation(e.detail.productData?.items[0].product_id));



;(function() {
  toggleMobileMenu();
    toggleCollectionX();


  // ─────────────────────────────────────────────────────────────────────────
  // 2) CART RECOMMENDATIONS: fetch & render related products
  // ─────────────────────────────────────────────────────────────────────────
  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function fetchCartRecommendations(productId, productLimit) {
    const section = document.getElementById("RelatedProducts");
    if (!section) return;

    const url = new URL("/recommendations/products.json", window.location.origin);
    url.searchParams.set("product_id",  productId);
    url.searchParams.set("limit",       productLimit);
    url.searchParams.set("intent",      "related");

    fetch(url)
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(data => {
        const products = data.products || [];
        if (!products.length) return;
        if (typeof generateProductHTML !== "function") {
          console.error("⚠️ generateProductHTML not defined; cannot render recommendations.");
          return;
        }

        section.innerHTML = products
          .filter(p => !p.handle.includes("gift-wrap"))
          .map(generateProductHTML)
          .join("");

        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("cart:recommendation:loaded", {
            detail: { products }
          }));
        }, 500);
      })
      .catch(err => console.error("Error fetching recommendations:", err));
  }

  function initRecommendation(id) {
    const fallback = document.getElementById("RelatedProducts")?.dataset.default;
    const pid = id || fallback;
    if (pid) fetchCartRecommendations(pid, 10);
  }

  function watchForRecommendationsContainer() {
    const observer = new MutationObserver(muts => {
      muts.forEach(m => m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        const found = node.id === "RelatedProducts"
          ? node
          : node.querySelector?.("#RelatedProducts");
        if (found) initRecommendation(found.dataset.default);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  onReady(() => {
    if (document.getElementById("RelatedProducts")) {
      initRecommendation();
    }
    watchForRecommendationsContainer();
  });

  document.addEventListener("theme:cart:added",   e => initRecommendation(e.detail.productData.items[0]?.product_id));
  document.addEventListener("theme:cart:removed", e => initRecommendation(e.detail.productData.items[0]?.product_id));

})();



theme.AssetsLoader.onPageLoaded(function () {
  (function ($) {
    let loader_require = [["styles", "plugin_slick"], ["scripts", "plugin_slick"]];

    theme.AssetsLoader.loadManually(loader_require, function () {
      announcementSlider();
      initializeSlider();
    });

    function announcementSlider() {
      $('#AnnouncementSlider').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        loop: true,
        dots: false,
        arrows: false,
        slidesToShow: 1
      });
    }
    
    function initializeSlider(reinit) {
      let slider = $(".collection--slider");
      let picker = $(".collection--picker");

      let settings = {
        autoplay: false,
        autoplaySpeed: 1000,
        infinite: true,
        loop: true,
        dots: true,
        arrows: false,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1
      };

      let pickersettings = {
        infinite: false,
        fullwidth: true,
        loop: false,
        dots: false,
        arrows: true,
        speed: 200,
        slidesToShow: 4, 
        slidesToScroll: 1,
        prevArrow: '<span class="prev"><svg width="7" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.04074 3.28284C4.19695 3.12663 4.19695 2.87337 4.04074 2.71716L1.49516 0.171573C1.33895 0.0153632 1.08568 0.0153632 0.929472 0.171573C0.773263 0.327783 0.773263 0.581048 0.929472 0.737258L3.19221 3L0.929472 5.26274C0.773263 5.41895 0.773263 5.67222 0.929472 5.82843C1.08568 5.98464 1.33895 5.98464 1.49516 5.82843L4.04074 3.28284ZM3.25391 3.4H3.7579V2.6H3.25391V3.4Z" fill="#19110C"/></svg></span>',
        nextArrow: '<span class="next"><svg width="7" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.04074 3.28284C4.19695 3.12663 4.19695 2.87337 4.04074 2.71716L1.49516 0.171573C1.33895 0.0153632 1.08568 0.0153632 0.929472 0.171573C0.773263 0.327783 0.773263 0.581048 0.929472 0.737258L3.19221 3L0.929472 5.26274C0.773263 5.41895 0.773263 5.67222 0.929472 5.82843C1.08568 5.98464 1.33895 5.98464 1.49516 5.82843L4.04074 3.28284ZM3.25391 3.4H3.7579V2.6H3.25391V3.4Z" fill="#19110C"/></svg></span>',
        responsive: [
        {
          breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      };

      if (reinit) {
        slider.slick("unslick");
        slider.slick(settings);
        
        slider.mouseover(function() {
          $(this).slick('play')
        });
        slider.mouseout(function() {
          $(this).slick('pause')
        });
      } else {
        slider.not(".slick-initialized").slick(settings);

        slider.mouseover(function() {
          $(this).slick('play')
        });
        slider.mouseout(function() {
          $(this).slick('pause')
        });
      }
    }

    window.initializeSlider = initializeSlider;

    $(function () {
      const $btns = $("#productImageSwitcher button");
        
      $btns.on("click", function () {
        $btns.removeClass("selected");
        $(this).addClass("selected");
    
        if ($(this).hasClass('model')) {
          $(".collection--slider.slick-initialized").slick('slickGoTo', 1);
        } else {
          $(".collection--slider.slick-initialized").slick('slickGoTo', 0);
        }
      });
    });
    
  })(jQueryTheme);
},["theme"]);


function fetchProductContent(getURL, callback) {
  let url = new URL(getURL, window.location.origin);
  url.search = '';
  url.searchParams.append('view', 'product-grid-item');
  return fetch(url).then(r => r.text()).catch(e => console.error('Error fetching product content:', e));
}

function Swatch() {
  document.addEventListener('click', function(e) {
         
    if (e.target.classList.contains('ajax-product-card') || e.target.parentElement.classList.contains('ajax-product-card')) {

      e.preventDefault();
      
      let url = e.target.href; 
      if (!url) return;

      e.target?.classList.add('focus');
      
      document.dispatchEvent(new Event('theme:loading:start'));
  
      let oldProduct = e.target.closest('product-item');
      
      fetchProductContent(url).then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        let newProduct = doc.getElementById('productGridItem');
  
        if (newProduct && oldProduct) {
          oldProduct.outerHTML = newProduct.innerHTML;
          document.dispatchEvent(new Event('theme:loading:end'));
          initializeSlider();
        }
      });
    }
  });
}

function sizeConverter(e) {
  const switcher = e.target.closest('.size'); 
  if (switcher) {
    const container = switcher.closest('#sizeSwitcher');
    if (!container) return;

    const switchers = container.querySelectorAll('.size');
    switchers.forEach(s => s.classList.remove('active'));
    switcher.classList.add('active');
    
    const sizeElements = container.closest('.product-options__section').querySelectorAll('.product-options__value');

    sizeElements.forEach(SE => {
      let convertSize = SE.dataset[switcher.dataset.size];
      if(convertSize === '') return;
      SE.innerText = convertSize;
    });
  }
}

document.addEventListener('click', sizeConverter);

function getVisibleHeight(element) {
  if (!element) return;
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  return Math.round(Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0)));
}

document.body.addEventListener('click', function(e) {
  let anchor = e.target.closest('a.feedback');
  if (anchor) anchor.classList.add('focus');
});

document.addEventListener("DOMContentLoaded", () => {
  Swatch();
  initializeGridSwitcher();
  initRecommendation(false);
  toggleMobileMenu();
  toggleCollectionX();
  initializeShareButton();
  updateVariantImage();
});


function observeSizeSwitcher() {
  const observer = new MutationObserver((mutations) => {
    const ukSizeButton = document.querySelector('.size[data-size="uk"]');
    if (ukSizeButton && !ukSizeButton.classList.contains('clicked')) {
      ukSizeButton.click(); 
      ukSizeButton.classList.add('clicked'); // Prevents multiple clicks on the same element
    }
  });

  // Observe the entire document for **any** changes
  observer.observe(document.body, { childList: true, subtree: true });
}

// Start observing when the document is loaded
document.addEventListener("DOMContentLoaded", observeSizeSwitcher);



document.addEventListener('DOMContentLoaded', function () {
  const images = document.querySelectorAll('a:has(img)');

  images.forEach(function (img) {
    img.addEventListener('click', function () {
      img.classList.toggle('focus');
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const images = document.querySelectorAll('.storista-wg img');

  images.forEach(function (img) {
    img.addEventListener('click', function () {
      img.classList.toggle('focus');
    });
  });
});


// judgeme
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const targetContainer   = document.querySelector('.jdgm-row-stars');
    const elementToMove     = document.querySelector('.jdgm-row-media');
  

    // proceed once everything is present
    if (targetContainer && elementToMove ) {
     // 2. Move the media row
      targetContainer.appendChild(elementToMove);

      

      console.log('✅ All elements moved and ordered correctly');

      obs.disconnect(); // stop observing
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});





document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const targetContainer   = document.querySelector('.jdgm-row-stars');
  
    const a                 = document.querySelector('.jdgm-rev-widg__summary');
    const b                 = document.querySelector('.jdgm-histogram.jdgm-temp-hidden');
    const c              = document.querySelector('.jdgm-rev-widg__summary-average');

    // proceed once everything is present
    if (targetContainer && a && b  && c) {
      // 1. Wrap a + b
      const wrapper = document.createElement('div');
      wrapper.className = 'my-wrapper';
      wrapper.appendChild(a);
      wrapper.appendChild(b);
      targetContainer.appendChild(wrapper);


      console.log('✅ All elements moved and ordered correctly');
      
      obs.disconnect(); // stop observing
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const actionsWrapper    = document.querySelector('.jdgm-widget-actions-wrapper');
    const formWrapper       = document.querySelector('.jdgm-form-wrapper');

    // proceed once everything is present
    if (actionsWrapper && formWrapper) {
      formWrapper.parentNode.insertBefore(actionsWrapper, formWrapper);
      obs.disconnect(); // stop observing
    }
  });
  document.querySelectorAll('.jdgm-histogram__row').forEach(row => {
        const rating = row.dataset.rating;                  // e.g. "5" or "3"
        const star    = row.querySelector('.jdgm-histogram__star');
        if (rating && star) {
          const span = document.createElement('span');
          span.className   = 'rating-badge';                // optional: for your styling
          span.textContent = rating;
          star.insertBefore(span, star.firstChild);
        }
      });

  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const   formWrapper  = document.querySelector('.jdgm-rev-widg__sort-wrapper');
    const  actionsWrapper      = document.querySelector('.jdgm-row-search');

    // proceed once everything is present
    if (actionsWrapper && formWrapper) {
      formWrapper.parentNode.insertBefore(actionsWrapper, formWrapper);
      obs.disconnect(); 
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    // 1. Find the reviews container
    const reviewsContainer = document.querySelector('.jdgm-rev-widg__reviews');
    if (!reviewsContainer) return;  // keep observing until it appears

    // 2. For each profile row inside it, append the badge if not already added
    reviewsContainer.querySelectorAll('.jdgm-row-profile').forEach(profile => {
      // Avoid duplicating the badge
      if (profile.querySelector('.kl_reviews__review__verified')) return;

      // 3. Create your badge element
      const badge = document.createElement('span');
      badge.className = 'kl_reviews__review__verified';
      badge.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0756/4715/6509/files/verified.svg?v=1749817364" width='15px' height='auto'>
        <span>Verified buyer</span>
      `;
      // 4. Append it into the profile row
      profile.appendChild(badge);
    });

    // Once we've injected badges into at least one profile, we can stop observing
    if (reviewsContainer.querySelector('.kl_reviews__review__verified')) {
      obs.disconnect();
      console.log('✅ Verified badges added to jdgm-row-profile elements');
    }
  });

  // Observe the entire document for new nodes
  observer.observe(document.body, { childList: true, subtree: true });
});
// judgeme



//new slider


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-swiper-section]').forEach(wrapper => {
    const sectionId = wrapper.dataset.swiperSection;
    let swiperEl = wrapper.querySelector(`.swiper-${sectionId}`);
    if (!swiperEl && wrapper.classList.contains(`swiper-${sectionId}`)) {
      swiperEl = wrapper;
    }
    if (!swiperEl) return;

    const swiper = new Swiper(swiperEl, {
      loop: true,
      simulateTouch: true,
      touchRatio: 1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: `.swiper-${sectionId} .swiper-pagination`,
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: `.swiper-button-next-${sectionId}`,
        prevEl: `.swiper-button-prev-${sectionId}`,
      },
      breakpoints: {
        0:   { slidesPerView: 1 },
        990: { slidesPerView: 1 },
      },
    });

    // ——> **NEW: true slide count** <——
    const slidesCount = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

    const progressContainer = wrapper.querySelector(`[data-progress-for="${sectionId}"]`);
    progressContainer.innerHTML = '';
if (slidesCount <= 1) {
  progressContainer.style.display = 'none';
  return;  // no need to build bars or hook events
}
    for (let i = 0; i < slidesCount; i++) {
      const bar = document.createElement('div');
      bar.className = 'progress-bar';
      bar.dataset.index = i;
      bar.innerHTML = `<div class="progress-bar-fill"></div>`;
      progressContainer.appendChild(bar);
      bar.addEventListener('click', () => swiper.slideToLoop(i));
    }

    const progressBars = progressContainer.querySelectorAll('.progress-bar');
    function updateProgress(activeIndex, percent) {
      progressBars.forEach((bar, idx) => {
        const fill = bar.querySelector('.progress-bar-fill');
        fill.style.transition = 'none';
        fill.style.width = (idx === activeIndex ? `${percent}%` : '0%');
      });
      const activeFill = progressBars[activeIndex].firstElementChild;
      void activeFill.offsetWidth;
      activeFill.style.transition = `width ${swiper.params.autoplay.delay}ms linear`;
      activeFill.style.width = '100%';
    }

    swiper.on('init',   () => updateProgress(swiper.realIndex, 0));
    swiper.on('slideChange', () => updateProgress(swiper.realIndex, 0));
    swiper.on('autoplayTimeLeft', (_s, timeLeft) => {
      const percent = ((swiper.params.autoplay.delay - timeLeft) / swiper.params.autoplay.delay) * 100;
      updateProgress(swiper.realIndex, percent);
    });

    swiper.init();
  });
});



// slider end

document.addEventListener('DOMContentLoaded', function() {
            const galleryContainer = document.querySelector('.product-gallery__fullscreen_slider');

            // Function to initialize Hammer.js on the current slide's image
            function initializeHammer() {
                // Remove previous Hammer instance if it exists
                if (window.currentHammer) {
                    window.currentHammer.destroy();
                }

                // Get the current slide's image
                const currentImage = galleryContainer.querySelector('.slick-current .rimage__img');
                if (!currentImage) return;

                // Ensure the image is loaded before attaching Hammer.js
                if (currentImage.complete) {
                    setupHammer(currentImage);
                } else {
                    currentImage.addEventListener('load', function() {
                        setupHammer(currentImage);
                    });
                }
            }

            // Function to set up Hammer.js gestures
            function setupHammer(image) {
                const hammer = new Hammer(image);

                // Add pinch recognizer
                const pinch = new Hammer.Pinch();
                hammer.add(pinch);

                // Add double-tap recognizer
                const doubleTap = new Hammer.Tap({ event: 'doubletap', taps: 2 });
                hammer.add(doubleTap);

                // Track scale
                let initialScale = 1;
                let currentScale = 1;
                const minScale = 1;
                const maxScale = 3;

                // Pinch start
                hammer.on('pinchstart', function(event) {
                    initialScale = currentScale;
                });

                // Pinch move
                hammer.on('pinchmove', function(event) {
                    currentScale = initialScale * event.scale;
                    currentScale = Math.min(Math.max(currentScale, minScale), maxScale);
                    image.style.transform = `scale(${currentScale})`;
                });

                // Double-tap to reset scale
                hammer.on('doubletap', function() {
                    currentScale = 1;
                    image.style.transform = `scale(${currentScale})`;
                });

                // Store the current Hammer instance
                window.currentHammer = hammer;
            }

            // Set up MutationObserver to detect when the gallery is populated
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.addedNodes.length > 0) {
                        // Slides have been added, initialize the slider if not already
                        if (!$(galleryContainer).hasClass('slick-initialized')) {
                            $(galleryContainer).slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: true,
                                dots: true
                            });
                        }
                        // Initialize Hammer.js on the current image
                        initializeHammer();
                    }
                });
            });

            // Observe changes to the gallery container's child nodes
            observer.observe(galleryContainer, { childList: true });

            // Re-initialize Hammer.js after each slide change
            $(galleryContainer).on('afterChange', function(event, slick, currentSlide) {
                initializeHammer();
            });
        });

window.addEventListener('DOMContentLoaded', () => {
  
  if (!/^\/collections\//.test(window.location.pathname)) return;
  // 1. Grab the very first image in .grid-product__image
  const firstImg = document.querySelector('.collection--image .collection-product-image img');
  const secondImg = document.querySelector('.collection--image:nth-of-type(2) .collection-product-image img');
  
  if (!firstImg) return;

  // 2. Put its src onto its parent container’s background
  const container = firstImg.closest('.collection-product-image');
  container.style.backgroundImage = `url(${secondImg.src})`;
  container.style.backgroundSize     = 'cover';            // or 'contain' if you want the whole image visible
  container.style.backgroundPosition = 'center center';    // center it
  container.style.backgroundRepeat   = 'no-repeat';

  // 3. IntersectionObserver to tease only that first image
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 4. Use the Web Animations API for the three-times tease
        entry.target.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(-25%)' },
          { transform: 'translateX(0)' }
        ], {
          duration: 2000,
          easing: 'ease-in-out',
          iterations: 2,
          fill: 'forwards'
        });

        // 5. Stop observing after the first trigger
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });

  // 6. Observe that image
  observer.observe(firstImg);
});


 document.addEventListener('DOMContentLoaded', () => {

  const marquee = document.querySelector('.logo-marquee');

  if(!marquee) return;

  marquee.addEventListener('click', () => {

    marquee.classList.toggle('is-paused');

  });

});

document.addEventListener('change', function(e){

  const select = e.target.closest('.cart-qty-select');

  if(!select) return;

  const wrapper = select.closest('.product-cart');

  const input = wrapper.querySelector(
    '.js-input-quantity-cart'
  );

  input.value = select.value;

  input.dispatchEvent(
    new Event('change', { bubbles: true })
  );

});